import(/* webpackMode: "eager" */ "/codebuild/output/src2785796416/src/online-ordering-system-website/src/app/contact-us/error.tsx");
